import { useHistory } from 'react-router-dom';

import useHeaderTitle from '../../hooks/useHeaderTitle';
import NotFound from './components/NotFound';

import './NotFoundPage.less';

const NotFoundPage = () => {
	const history = useHistory();

	useHeaderTitle('金飯碗 Gold Rice Bowl', true);

	const handleGoHome = () => {
		history.push('/booking');
	};

	return (
		<div className="not-found-container">
			<NotFound onGoHome={handleGoHome} />
		</div>
	);
};

export default NotFoundPage;
